import { ACTION } from "./enums";
export var DIFFICULTY;
(function (DIFFICULTY) {
    DIFFICULTY[DIFFICULTY["easy"] = 0] = "easy";
    DIFFICULTY[DIFFICULTY["normal"] = 1] = "normal";
    DIFFICULTY[DIFFICULTY["hard"] = 2] = "hard";
    DIFFICULTY[DIFFICULTY["expert"] = 3] = "expert";
    DIFFICULTY[DIFFICULTY["custom"] = 4] = "custom";
})(DIFFICULTY || (DIFFICULTY = {}));
export const difficulties = [
    {
        width: 11,
        height: 8,
        bombs: 10,
    },
    {
        width: 20,
        height: 14,
        bombs: 39,
    },
    {
        width: 29,
        height: 20,
        bombs: 102,
    },
    {
        width: 38,
        height: 26,
        bombs: 230,
    }
];
export const settings = {
    difficulty: DIFFICULTY.normal,
    board: difficulties[DIFFICULTY.normal],
    question: false,
    primary_action: ACTION.OPEN
};
export function applyDifficulty(difficulty, bs) {
    if (difficulty === DIFFICULTY.custom) {
        settings.board = bs;
    }
    else {
        settings.board = difficulties[difficulty];
    }
    ;
}
